module.exports = __webpack_public_path__ + "../resources/img/lang_img5.39bace77.png";